import { useState } from 'react';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import PricingChart from './PricingChart';
import OptimizationChart from './OptimizationChart';

export default function CombPriceOptimSection({ site, startDate, endDate, msSessionInfo, refreshKey }) {
    const [expandedChart, setExpandedChart] = useState(null);

    const isPricingExpanded = expandedChart === 'pricing';
    const isOptimizationExpanded = expandedChart === 'optimization';

    const handlePricingToggle = () => {
        setExpandedChart(prev => (prev === 'pricing' ? null : 'pricing'));
    };

    const handleOptimizationToggle = () => {
        setExpandedChart(prev => (prev === 'optimization' ? null : 'optimization'));
    };

    return (
        <Grid container spacing={3}>
            <Grid
                item
                xs={12}
                md={isPricingExpanded ? 12 : 6}
                lg={isPricingExpanded ? 12 : 6}
                style={{ display: isOptimizationExpanded ? 'none' : 'block' }}
            >
                <PricingChart
                    key={`optim-${refreshKey}`}
                    site={site}
                    startDate={startDate}
                    endDate={endDate}
                    msSessionInfo={msSessionInfo}
                    expandContractChart={handlePricingToggle}
                    refreshKey={refreshKey}
                />
            </Grid>

            <Grid
                item
                xs={12}
                md={isOptimizationExpanded ? 12 : 6}
                lg={isOptimizationExpanded ? 12 : 6}
                style={{ display: isPricingExpanded ? 'none' : 'block' }}
            >
                <OptimizationChart
                    key={`optim-${refreshKey}`}
                    site={site}
                    startDate={startDate}
                    endDate={endDate}
                    msSessionInfo={msSessionInfo}
                    expandContractChart={handleOptimizationToggle}
                    refreshKey={refreshKey}
                />
            </Grid>
        </Grid>
    );
}

CombPriceOptimSection.propTypes = {
    site: PropTypes.object.isRequired,
    startDate: PropTypes.object,
    endDate: PropTypes.object,
    msSessionInfo: PropTypes.object.isRequired,
    refreshKey: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
};